import React from "react";
import { FieldProps } from "formik";

import { TextFieldProps } from "@material-ui/core/TextField";

import { FormikTextField } from "./FormikTextField";
import { RawTextField } from "./RawTextField";

type IProps = TextFieldProps;
type TextFieldFormikProps = IProps & FieldProps;

// See (for variant as any): https://github.com/Microsoft/TypeScript/issues/28791
export const TextField: React.FunctionComponent<IProps> = ({
  margin = "dense",
  variant = "outlined",
  fullWidth = true,
  type = "text",
  disabled = false,
  InputProps,
  ...props
}: IProps) => {
  const { field, form } = props as TextFieldFormikProps;
  const isFormikConnected = form && field;

  return isFormikConnected ? (
    <FormikTextField
      margin={margin}
      variant={variant as any}
      fullWidth={fullWidth}
      type={type}
      disabled={disabled}
      InputProps={InputProps}
      {...props}
    />
  ) : (
    <RawTextField
      margin={margin}
      variant={variant as any}
      fullWidth={fullWidth}
      type={type}
      disabled={disabled}
      InputProps={InputProps}
      {...props}
    />
  );
};
